import { useMutation, useQueryClient } from 'react-query'
import { postJSON } from 'common/services/api'
import { STOCK_COUNT_URL, STOCK_LOGS_QUERY_KEY } from './queryConstants'
import { StockCheckData } from '../modalsV2/StockCheckModal'

type UseStockCheckProps = {
  residentId: string
  residentMedicationId: string
  expectedStock: number
  onSuccess?: () => void
  onError?: (error: any) => void
}

type StockCheckRequest = {
  residentId: string
  residentMedicationId: string
  timeLogged: string
  stockCount: number
  notes: string
  flagForHandover: boolean
  witnessIds: string[]
  discrepancyReason?: string
  resolveDiscrepancy: boolean
  mediaAttachments: any[]
}

export const useStockCheck = ({
  residentId,
  residentMedicationId,
  expectedStock,
  onSuccess,
  onError
}: UseStockCheckProps) => {
  const queryClient = useQueryClient()

  const mutation = useMutation(
    (data: StockCheckData) => {
      const hasDiscrepancy =
        !data.isExpectedStockAccurate && data.stockCount !== expectedStock
      const resolveDiscrepancy =
        hasDiscrepancy && data.resolveDiscrepancy === 'yes'

      const requestBody: StockCheckRequest = {
        residentId,
        residentMedicationId,
        timeLogged: new Date().toISOString(),
        stockCount: data.stockCount,
        notes: data.description,
        flagForHandover: false,
        witnessIds: [],
        discrepancyReason: resolveDiscrepancy
          ? data.discrepancyReason
          : undefined,
        resolveDiscrepancy: resolveDiscrepancy,
        mediaAttachments: []
      }

      return postJSON({
        url: STOCK_COUNT_URL,
        json: requestBody
      })
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([STOCK_LOGS_QUERY_KEY])
        onSuccess?.()
      },
      onError: (error) => {
        console.error('Error saving stock check:', error)
        onError?.(error)
      }
    }
  )

  return {
    createStockCheck: mutation.mutateAsync,
    isLoading: mutation.isLoading
  }
}

export default useStockCheck

